(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sh-collection-sort"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function (event) {
  if (!event.target.matches('[data-sh-sort]') || event.target.closest('[data-sh-collection]')) return;
  var url = new URL(window.location.href);
  url.searchParams.set('sort_by', event.target.value);
  url.searchParams.delete('page');
  window.location.assign(url.href);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sh-product-lightbox"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sh-product-lightbox')) {
    customElements.define('sh-product-lightbox', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.dialog = this.querySelector('dialog');
        this.viewport = this.querySelector('[data-viewport]');
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.photos = Array.from(this.querySelectorAll('template[data-photo-id]'));
        this.counter = this.querySelector('[data-counter]');
        this.pointers = new Map();
        this.index = 0;
        this.scale = 1;
        this.x = this.y = 0;
        document.addEventListener('click', event => {
          const opener = event.target.closest('modal-opener.product__modal-opener--image');
          if (!opener || opener.dataset.modal !== this.dataset.modalTarget || !this.dialog.showModal) return;
          const button = opener.querySelector('button[data-media-id]');
          const index = this.photos.findIndex(photo => photo.dataset.photoId === button?.dataset.mediaId);
          if (index < 0) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.open(index, button, event.detail === 0);
        }, { capture: true, signal });
        this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close(), { signal });
        this.dialog.addEventListener('pointerdown', event => {
          this.outsideDown = event.target === this.dialog;
        }, { signal });
        this.dialog.addEventListener('click', event => {
          if (event.target === this.dialog && this.outsideDown) this.dialog.close();
          this.outsideDown = false;
        }, { signal });
        this.dialog.addEventListener('close', () => this.cleanup(), { signal });
        this.dialog.addEventListener('keydown', event => {
          this.dialog.dataset.keyboard = 'true';
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            event.stopPropagation();
            this.go(event.key === 'ArrowLeft' ? -1 : 1);
          } else if (event.key === '+' || event.key === '=' || event.key === '-') {
            event.preventDefault();
            this.transform(event.key === '-' ? 1 : Math.min(4, this.scale + 1), 0, 0);
          }
        }, { signal });
        this.viewport.addEventListener('pointerdown', event => this.pointerDown(event), { signal });
        this.viewport.addEventListener('pointermove', event => this.pointerMove(event), { signal });
        this.viewport.addEventListener('pointerup', event => this.pointerEnd(event), { signal });
        this.viewport.addEventListener('pointercancel', event => this.pointerEnd(event), { signal });
        this.viewport.addEventListener('lostpointercapture', event => this.pointerEnd(event), { signal });
        this.viewport.addEventListener('dragstart', event => event.preventDefault(), { signal });
        this.viewport.addEventListener('wheel', event => {
          event.preventDefault();
          const point = this.point(event);
          this.zoomAt(this.scale * Math.exp(-event.deltaY * 0.002), point);
        }, { passive: false, signal });
        window.addEventListener('resize', () => {
          if (this.dialog.open) {
            this.cancelGesture();
            this.shift(0);
            this.transform(this.scale, this.x, this.y);
          }
        }, { signal });
      }

      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.cleanup();
        this.controller?.abort();
      }

      open(index, opener, keyboard = false) {
        if (this.dialog.open) return;
        this.opener = opener;
        this.dialog.dataset.keyboard = String(keyboard);
        this.scroll = { x: window.scrollX, y: window.scrollY };
        this.bodyStyle = document.body.getAttribute('style');
        Object.assign(document.body.style, { position: 'fixed', top: `${-this.scroll.y}px`, left: `${-this.scroll.x}px`, width: '100%', overflow: 'hidden' });
        this.dialog.showModal();
        this.showPhoto(index);
        this.querySelector('[data-close]').focus({ preventScroll: true });
        window.pauseAllMedia?.();
      }

      cleanup() {
        clearTimeout(this.slideTimer);
        this.animating = false;
        this.cancelGesture();
        if (!this.scroll) return;
        if (this.bodyStyle === null) document.body.removeAttribute('style');
        else document.body.setAttribute('style', this.bodyStyle);
        window.scrollTo({ left: this.scroll.x, top: this.scroll.y, behavior: 'instant' });
        this.scroll = null;
        this.opener?.focus({ preventScroll: true });
      }

      showPhoto(index) {
        this.index = (index + this.photos.length) % this.photos.length;
        this.slides.forEach((slide, slot) => {
          const photoIndex = (this.index + slot - 1 + this.photos.length) % this.photos.length;
          slide.replaceChildren(this.photos[photoIndex].content.cloneNode(true));
        });
        this.image = this.slides[1].querySelector('img');
        this.counter.textContent = `${this.index + 1} / ${this.photos.length}`;
        this.track.style.transition = 'none';
        this.shift(0);
        this.transform(1, 0, 0);
      }

      shift(offset) {
        this.track.style.transform = `translate3d(${-this.viewport.clientWidth + offset}px, 0, 0)`;
      }

      go(direction) {
        if (this.photos.length < 2 || this.animating) return;
        this.cancelGesture();
        this.transform(1, 0, 0);
        const duration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 180;
        this.animating = true;
        this.track.style.transition = `transform ${duration}ms ease-out`;
        this.shift(-direction * this.viewport.clientWidth);
        this.slideTimer = setTimeout(() => {
          this.showPhoto(this.index + direction);
          this.animating = false;
        }, duration);
      }

      point(event) {
        const rect = this.viewport.getBoundingClientRect();
        return { x: event.clientX - rect.left - rect.width / 2, y: event.clientY - rect.top - rect.height / 2 };
      }

      transform(scale, x, y) {
        this.scale = Math.max(1, Math.min(4, scale));
        const width = this.viewport.clientWidth;
        const height = this.viewport.clientHeight;
        const maxX = Math.max(0, (width * this.scale - width) / 2);
        const maxY = Math.max(0, (height * this.scale - height) / 2);
        this.x = Math.max(-maxX, Math.min(maxX, x));
        this.y = Math.max(-maxY, Math.min(maxY, y));
        if (this.image) this.image.style.transform = `translate3d(${this.x}px, ${this.y}px, 0) scale(${this.scale})`;

      }

      zoomAt(scale, point) {
        const next = Math.max(1, Math.min(4, scale));
        this.transform(next, point.x - (point.x - this.x) * next / this.scale, point.y - (point.y - this.y) * next / this.scale);
      }

      startGesture() {
        const points = Array.from(this.pointers.values());
        if (points.length >= 2) {
          const [a, b] = points;
          const mid = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
          this.pinched = true;
          this.gesture = { mode: 'pinch', distance: Math.max(1, Math.hypot(a.x - b.x, a.y - b.y)), scale: this.scale, anchorX: (mid.x - this.x) / this.scale, anchorY: (mid.y - this.y) / this.scale };
          this.shift(0);
        } else if (points.length) {
          this.gesture = { mode: this.scale > 1.02 || this.pinched ? 'pan' : 'swipe', start: points[0], x: this.x, y: this.y };
        }
      }

      pointerDown(event) {
        if (this.animating || (event.pointerType === 'mouse' && event.button !== 0)) return;
        if (this.pointers.size === 0) this.pinched = false;
        this.track.style.transition = 'none';
        this.pointers.set(event.pointerId, this.point(event));
        this.viewport.setPointerCapture(event.pointerId);
        this.startGesture();
      }

      pointerMove(event) {
        if (!this.pointers.has(event.pointerId)) return;
        const point = this.point(event);
        this.pointers.set(event.pointerId, point);
        const gesture = this.gesture;
        if (gesture.mode === 'pinch') {
          const [a, b] = Array.from(this.pointers.values());
          const next = Math.max(1, Math.min(4, gesture.scale * Math.hypot(a.x - b.x, a.y - b.y) / gesture.distance));
          this.transform(next, (a.x + b.x) / 2 - gesture.anchorX * next, (a.y + b.y) / 2 - gesture.anchorY * next);
        } else {
          const dx = point.x - gesture.start.x;
          const dy = point.y - gesture.start.y;
          if (gesture.mode === 'pan') this.transform(this.scale, gesture.x + dx, gesture.y + dy);
          else if (this.photos.length > 1 && Math.abs(dx) > Math.abs(dy)) this.shift(Math.max(-this.viewport.clientWidth, Math.min(this.viewport.clientWidth, dx)));
        }
      }

      pointerEnd(event) {
        if (!this.pointers.has(event.pointerId)) return;
        const point = this.point(event);
        const gesture = this.gesture;
        this.pointers.delete(event.pointerId);
        if (event.type !== 'pointerup') {
          this.cancelGesture();
          this.shift(0);
          return;
        }
        if (this.pointers.size) {
          this.startGesture();
          return;
        }
        const dx = gesture.start ? point.x - gesture.start.x : 0;
        const dy = gesture.start ? point.y - gesture.start.y : 0;
        if (!this.pinched && gesture.mode === 'swipe' && Math.abs(dx) > Math.max(40, this.viewport.clientWidth * 0.12) && Math.abs(dx) > Math.abs(dy) * 1.2) {
          this.go(dx < 0 ? 1 : -1);
        } else {
          this.shift(0);

        }
        this.gesture = null;
      }

      cancelGesture() {
        this.pointers?.clear();
        this.gesture = null;
        this.pinched = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["syd-cart-discount"] && !Shopify.designMode) return;
  try {
    (function () {
    var busy = false;

    function activeCodes(cart) {
      if (Array.isArray(cart.discount_codes)) {
        return cart.discount_codes.filter(function (entry) { return entry.applicable !== false; })
          .map(function (entry) { return entry.code; });
      }
      var applications = (cart.cart_level_discount_applications || []).slice();
      (cart.items || []).forEach(function (item) {
        (item.line_level_discount_allocations || []).forEach(function (allocation) {
          applications.push(allocation.discount_application);
        });
      });
      return Array.from(new Set(applications.filter(function (entry) {
        return entry && entry.type === 'discount_code';
      }).map(function (entry) { return entry.title; })));
    }

    async function updateDiscount(widget, button, code, remove) {
      if (busy) return;
      busy = true;
      var message = widget.querySelector('.syd-cart-discount__message');
      var originalLabel = button.textContent;
      var controls = widget.querySelectorAll('button, input');
      message.hidden = true;
      widget.setAttribute('aria-busy', 'true');
      controls.forEach(function (control) { control.disabled = true; });
      button.textContent = remove ? widget.dataset.removing : widget.dataset.applying;
      var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

      async function post(codes) {
        var response = await fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: codes.join(',') })
        });
        if (!response.ok) throw new Error(widget.dataset.error);
        return response.json();
      }

      try {
        var currentResponse = await fetch(root + 'cart.js', { cache: 'no-store' });
        if (!currentResponse.ok) throw new Error(widget.dataset.error);
        var previous = activeCodes(await currentResponse.json());
        var requested = remove ? previous.filter(function (existing) {
          return existing.toLowerCase() !== code.toLowerCase();
        }) : [code];
        var updated = await post(requested);
        var matching = Array.isArray(updated.discount_codes)
          ? updated.discount_codes.find(function (entry) { return entry.code.toLowerCase() === code.toLowerCase(); })
          : null;
        var applied = matching ? matching.applicable !== false : activeCodes(updated).some(function (existing) {
          return existing.toLowerCase() === code.toLowerCase();
        });
        if ((!remove && !applied) || (remove && applied)) {
          await post(previous);
          throw new Error(remove ? widget.dataset.error : widget.dataset.invalid);
        }
        var url = new URL(window.location.href);
        url.searchParams.delete('discount');
        window.history.replaceState(null, '', url.toString());
        window.location.reload();
      } catch (error) {
        message.textContent = error.message || widget.dataset.error;
        message.hidden = false;
      } finally {
        busy = false;
        widget.removeAttribute('aria-busy');
        controls.forEach(function (control) { control.disabled = false; });
        button.textContent = originalLabel;
      }
    }

    document.addEventListener('submit', function (event) {
      if (event.target.id !== 'SydCartDiscountForm') return;
      event.preventDefault();
      var form = event.target;
      var code = form.querySelector('input[name="discount"]').value.trim();
      if (!code) return;
      updateDiscount(form.closest('.syd-cart-discount'), form.querySelector('button[type="submit"]'), code, false);
    });

    document.addEventListener('click', function (event) {
      var button = event.target.closest('.syd-cart-discount__remove');
      if (!button) return;
      event.preventDefault();
      updateDiscount(button.closest('.syd-cart-discount'), button, button.dataset.removeCode, true);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["syd-cart-sticky"] && !Shopify.designMode) return;
  try {
    (function () {
    function bindCartBar() {
      var footer = document.getElementById('main-cart-footer');
      var bar = document.getElementById('SydStickyCart');
      if (!footer || !bar || footer.dataset.sydSyncBound) return;
      footer.dataset.sydSyncBound = '1';
      var timer;
      var lastHeight;
      var lastWalletScale;
      var walletLayoutWidth = 560;

      function fitWallets() {
        var wallets = bar.querySelector('.syd-sticky-cart__wallets');
        if (!wallets || !wallets.clientWidth) return;
        var compact = window.matchMedia('(max-width: 989px)').matches;
        var layoutWidth = Math.max(walletLayoutWidth, wallets.clientWidth);
        var scale = compact ? wallets.clientWidth / layoutWidth : 1;
        if (scale === lastWalletScale) return;
        lastWalletScale = scale;
        wallets.style.setProperty('--syd-wallet-layout-width', layoutWidth + 'px');
        wallets.style.setProperty('--syd-wallet-scale', String(scale));
      }

      function syncTotal() {
        var source = document.getElementById('SydGrandTotal');
        var target = document.getElementById('SydStickyTotal');
        if (source && target) {
          var value = source.textContent.trim();
          if (target.textContent.trim() !== value) target.textContent = value;
        }
      }

      function reserveSpace() {
        fitWallets();
        var height = Math.ceil(bar.getBoundingClientRect().height);
        if (height === lastHeight) return;
        lastHeight = height;
        document.documentElement.style.setProperty('--syd-cart-bar-height', height + 'px');
      }

      function refresh() {
        if (!footer.classList.contains('is-empty') && window.sydShippingEstimator && typeof window.sydShippingEstimator.render === 'function') {
          window.sydShippingEstimator.render();
        }
        syncTotal();
        reserveSpace();
      }

      function isOwnWrite(node) {
        var element = node && (node.nodeType === 1 ? node : node.parentElement);
        return element && element.closest && element.closest('#shipping-estimator, #SydStickyCart, .syd-summary__row--grand');
      }

      new MutationObserver(function (mutations) {
        syncTotal();
        reserveSpace();
        if (mutations.some(function (mutation) { return !isOwnWrite(mutation.target); })) {
          clearTimeout(timer);
          timer = setTimeout(refresh, 120);
        }
      }).observe(footer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

      if ('ResizeObserver' in window) new ResizeObserver(reserveSpace).observe(bar);
      window.addEventListener('resize', reserveSpace);
      refresh();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindCartBar);
    else bindCartBar();
    document.addEventListener('shopify:section:load', bindCartBar);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["syd-duty-info"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  document.querySelectorAll('.syd-duty-info[open]').forEach((info) => {
    if (!info.contains(event.target)) info.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.syd-duty-info[open]').forEach((info) => {
    info.open = false;
    info.querySelector('summary').focus();
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["syd-returns-dialog"] && !Shopify.designMode) return;
  try {
    if (!window.sydReturnsDialogBound) {
    window.sydReturnsDialogBound = true;
    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-syd-returns-open]');
      if (opener) {
        document.getElementById('SydReturnsDialog')?.showModal();
        return;
      }
      var dialog = document.getElementById('SydReturnsDialog');
      if (dialog && (event.target.closest('[data-syd-returns-close]') || event.target === dialog)) dialog.close();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
